var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"drop-content-button",class:{'--is-active':_vm.active},on:{"click":_vm.setClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }